module.exports = __webpack_public_path__ + "static/seo-placeholder-08d41689ca729bd66b6d9dc41c0573ac.png";